import { useSelector } from "react-redux";
import { LocationSeparate } from "../helpers/LocationSeparatePath";
import { AnalityRoot, CmsRoot, InmersysRoot, graphRoot } from "../router/type_router";
import { Bulb, CmsIcon, Graphics, Key, Warning } from "../components/icons";
import { menuIcons } from "../assets/icons/menu";

export const useMenuIteams = (local = "/") => {
    const path = LocationSeparate(local);
    const {
        auth: { isAdmin, isSuperAdmin, isUser, isViewer },
    } = useSelector((state) => state);

    const openSubMenu = ["sub1", "sub2", "root1", "internal1"];

    let selectIteam = InmersysRoot.root;
    if (path) {
        selectIteam = path;
    }

    const getItem = (label, key, icon, children, type) => {
        return {
            key,
            icon,
            children,
            label,
            type,
        };
    };
    const menuGLobal = {
        generalView: getItem("General", InmersysRoot.root, <img className="" src={menuIcons.general} alt="general menu" />),
        graphInternal: getItem("Internos", `${InmersysRoot.graph}/${graphRoot.internal}`, <img src={menuIcons.internal} alt="internal menu" />),
        graphArea: getItem("Áreas", `${InmersysRoot.graph}/${graphRoot.area}`, <img src={menuIcons.areas} alt="areas menu" />),
        panelControl: {
            user: getItem("Usuarios", InmersysRoot.user, <img src={menuIcons.users} alt="users menu" />),
            newProject: getItem("Nuevo proyecto", InmersysRoot.newProject, <img src={menuIcons.project} alt="project menu" />),
        },
        anality: {
            planning: getItem(
                "Análisis de planeación",
                `${InmersysRoot.anality}/${AnalityRoot.sizeProyect}`,
                <img src={menuIcons.projectSize} alt="projectSize menu" />
            ),
            download: getItem(
                "Tabla de horas",
                `${InmersysRoot.anality}/${AnalityRoot.download}`,
                <img src={menuIcons.projectHours} alt="projectHours menu" />
            ),
            overtime: getItem("Proyectos en rojo", `${InmersysRoot.anality}/${AnalityRoot.redProjects}`, <img src={menuIcons.projectred} alt="project red" />),
            tableWeeks: getItem("Tabla de semanas", `${InmersysRoot.anality}/${AnalityRoot.tableWeeks}`, <img src={menuIcons.projectHours} alt="projectHours menu" />),
        },
        cms: {
            area: getItem("Areas", `${InmersysRoot.cms}/${CmsRoot.area}`, <img src={menuIcons.areas} alt="areas menu" />),
            platform: getItem("Plataformas", `${InmersysRoot.cms}/${CmsRoot.plaforms}`, <img src={menuIcons.areas} alt="areas menu" />),
            categories: getItem("Categorias", `${InmersysRoot.cms}/${CmsRoot.categories}`, <img src={menuIcons.areas} alt="areas menu" />),
            tags: getItem("Etiquetas", `${InmersysRoot.cms}/${CmsRoot.tags}`, <img src={menuIcons.trafficLight} alt="areas menu" />),
            reasonpause: getItem("Pausas", `${InmersysRoot.cms}/${CmsRoot.pauses}`, <img src={menuIcons.trafficLight} alt="areas menu" />),
        },
        projects: {
            client: getItem("Clientes", InmersysRoot.projectinmersys, <img src={menuIcons.projectSize} alt="areas menu" />),
            intern: getItem("Interno", `${InmersysRoot.projectinmersys}?own=true`, <img src={menuIcons.internal} alt="areas menu" />),
            buscador: getItem("Buscador", `${InmersysRoot.buscador}`, <img src={menuIcons.projectSize} alt="areas menu" />),
        },
        graphSemaforo: getItem(
            "Semáforo",
            `${InmersysRoot.graph}/${graphRoot.semaforo}`,
            <img src={menuIcons.trafficLight} alt="trafficLight menu" />
        ),
    };

    const { generalView, panelControl, cms, projects, graphInternal, graphArea, graphSemaforo, anality } = menuGLobal;

    //* Vista de Menus
    const viewSuperAdmin = [
        getItem("Gráficas", "root1", <Graphics />, [generalView, graphInternal, graphArea, graphSemaforo]),
        getItem("Panel de control", "sub1", <Key />, [panelControl.user, panelControl.newProject]),
        getItem("Análisis", "internal1", <Bulb />, [anality.planning, anality.download, anality.tableWeeks]),
        getItem("CMS", "subcms", <CmsIcon />, [cms.area, cms.categories, cms.platform, cms.tags, cms.reasonpause]),
        getItem("Proyectos", "sub2", <Warning />, [projects.client, projects.intern, projects.buscador]),
    ];

    const viewAdmin = [
        getItem("Gráficas", "root1", <Graphics />, [generalView, graphInternal, graphArea, graphSemaforo]),
        getItem("Proyectos", "sub2", <Warning />, [projects.client, projects.intern, projects.buscador]),
    ];

    const viewUser = [
        getItem("Gráficas", "root1", <Graphics />, [generalView, graphInternal, graphArea, graphSemaforo]),
        getItem("Proyectos", "sub2", <Warning />, [projects.client, projects.intern]),
    ];

    const viewViewer = [
        getItem("Gráficas", "root1", <Graphics />, [generalView, graphInternal, graphArea, graphSemaforo]),
        getItem("Proyectos", "sub2", <Warning />, [projects.client, projects.intern, projects.buscador]),
    ];


    // * Join Menus
    let iteamsMenu = [];
    if (isSuperAdmin) {
        iteamsMenu = [].concat(viewSuperAdmin);
    }

    if (isAdmin) {
        iteamsMenu = [].concat(viewAdmin);
    }

    if (isUser) {
        iteamsMenu = [].concat(viewUser);
    }

    if (isViewer) {
        iteamsMenu = [].concat(viewViewer);
    }

    return { iteamsMenu, selectIteam, openSubMenu };
};
